import { EntidadeBase } from 'hay-core-react';
class TarefaAgendadaLogModel extends EntidadeBase {
    constructor() {
        super('tarefaagendadalog');
    }
}
const instance = new TarefaAgendadaLogModel();
export default instance;
